import React from 'react';
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import useAuthContext from '../../providers/authProvider';

const SignIn = () => {
  const { login } = useAuthContext();

  const { t } = useTranslation();

  const submit = (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);
    const email = formData.get('email');
    const password = formData.get('password');

    login({email, password})
  }

  return (
    <div className='unauthorized-container'>
      <div className="login-page">
        <div className="login-page-logo">
          <img src="/images/logo.png"/>
            <div>Supercoach</div>
        </div>
        <div className="login-page-title">{t('signIn.club')}</div>

        <div className="login-page-form">
          <form className="new_club_admin" onSubmit={submit}>
            <div className="form-group form-group-lg">
              <label htmlFor="club_admin_email">{t('common.table_email')}</label><br/>
              <input autoFocus="autofocus" className="form-control" type="email" name="email"/>
            </div>

            <div className="form-group form-group-lg">
              <label htmlFor="club_admin_password">{t('signIn.password')}</label><br/>
              <input autoComplete="off" className="form-control" type="password" name="password"/>
            </div>


            <div className="actions">
              <button type="submit" name="commit" className="btn btn-success btn-lg">{t('signIn.log_in')}</button>
              <Link to="/club_admin/forgot_password">
              {t('signIn.forgot')}
              </Link>
              <br/>
            </div>
          </form>
        </div>
      </div>
    </div>

  )
};

export default SignIn;
